import React from 'react';
import { Icon } from '@chakra-ui/icons';
import { Color } from 'src/theme/color';

export const ActionCopyId = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="11px"
			viewBox="0 0 11 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.45508 5.84223C4.64882 6.10124 4.896 6.31555 5.17986 6.47064C5.46371 6.62572 5.7776 6.71794 6.10023 6.74105C6.42285 6.76415 6.74668 6.7176 7.04974 6.60455C7.35279 6.49151 7.62799 6.3146 7.85667 6.08584L9.21009 4.73242C9.62098 4.307 9.84834 3.7372 9.8432 3.14576C9.83806 2.55433 9.60083 1.98857 9.18261 1.57035C8.76439 1.15212 8.19863 0.914893 7.60719 0.909753C7.01575 0.904614 6.44596 1.13198 6.02053 1.54287L5.24457 2.31432"
				stroke={Color.BACKGROUND_TERTIARY}
				strokeWidth="1.07554"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.2593 4.93995C6.06556 4.68094 5.81838 4.46663 5.53453 4.31154C5.25067 4.15646 4.93679 4.06424 4.61416 4.04113C4.29153 4.01803 3.9677 4.06458 3.66465 4.17763C3.36159 4.29068 3.08639 4.46758 2.85771 4.69634L1.50429 6.04976C1.0934 6.47519 0.86604 7.04498 0.871179 7.63642C0.876318 8.22785 1.11355 8.79361 1.53177 9.21183C1.95 9.63006 2.51575 9.86729 3.10719 9.87243C3.69863 9.87757 4.26842 9.6502 4.69385 9.23931L5.4653 8.46786"
				stroke={Color.BACKGROUND_TERTIARY}
				strokeWidth="1.07554"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
